import Api from "./Api.js";

const resource = "/discounts";

export default {
  search(params) {
    return Api.get(`${resource}`, { params });
  },
  store(attributes) {
    return Api.post(`${resource}`, attributes);
  },
};
